import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import TablePagination from "@material-ui/core/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { Typography, Box, Button } from "@material-ui/core/";
import PresentToAll from "@material-ui/icons/PresentToAll";
import { useSelector, useDispatch } from "react-redux";
import {
  getClassData,
  clearErrorStatusCode,
  clearErrorMessage,
  clearClassData,
  getTermData,
  updateParmsForClass,
  setErrorMessage,
  getAttendanceData,
} from "../../../../reduxSlices/classesSlice";
import {
  isObjectEmpty,
  classStatusOptionList,
  statusOptionList,
  getCurrentDateTimeInCT,
  parseDatabaseDateAsCT,
} from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import localizedStrings from "../../../../utils/localize";
import Attendance from "../Attendance";
import {
  getOptionList,
  getAnotherOptionList,
} from "../../../../reduxSlices/applicationSlice";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
});

function PageConatiner(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [termsData, setTerms] = useState("");
  const [statusesData, setStatuses] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [studentId, setStudentId] = useState(undefined);
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [modalTableMapData, setModalTableMapData] = useState([]);
  const optionList = useSelector((state) => state.applicationData.optionList);
  const anotherOptionList = useSelector(
    (state) => state.applicationData.anotherOptionList,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const [tableMapData, setTableMapData] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const [displayMessage, setDisplayMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  const [sessionId, setSessionId] = useState(null);
  const [payload, setPayload] = useState(null);
  const classData = useSelector((state) => state.classData.classData);
  const terms = useSelector((state) => state.classData.terms);
  const dataFetchingStatus = useSelector(
    (state) => state.classData.dataFetchingStatus,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );

  const errorMessage = useSelector((state) => state.classData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.classData.errorStatusCode,
  );
  useEffect(() => {
    dispatch(getClassData(window.localStorage.getItem("x-auth-contactId")));
    dispatch(getTermData());
  }, [dispatch]);

  useEffect(() => {
    let entity = "ses_session";
    let attributename = "ses_studentstatus";
    dispatch(getOptionList(entity, attributename));
    let classEntity = "ses_class";
    let classAttributename = "ses_classstatus";
    dispatch(getAnotherOptionList(classEntity, classAttributename));
  }, [dispatch]);

  const funcOptionList = (status) => {
    var value;
    if (!isObjectEmpty(optionList) && optionList?.length != 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
      });
    }
    return statusOptionList(value);
  };

  useEffect(() => {
    if (applicantStatus.ses_applicantstatus) {
      setStudentId(applicantStatus.ses_applicantstatus.ses_studentid);
    }
  }, [applicantStatus]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };

  const handleOpenModal = (e, sessionId, element) => {
    e.preventDefault();
    setSessionId(sessionId);
    setPayload(element);
    if (element.usb_requiresacorequisite === true) {
      setOpen1(true);
    } else {
      setOpen(true);
    }
  };
  const handleUpdate = () => {
    dispatch(
      updateParmsForClass({
        ses_sessionid: payload?.ses_sessionid,
        usb_requiresacorequisite: payload?.usb_requiresacorequisite,
        _ses_term_value: payload?._ses_term_value,
        ses_courseid: payload?.ses_courseid,
        _ses_studentid_value: studentId,
      }),
    );
    setOpen(false);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearClassData());
    props.history.push("/login");
  };
  const removeDuplicateFromObjects = (objectArray, field) => {
    if (objectArray?.length > 0) {
      if (field === "termName")
        return objectArray
          .filter(
            (v, i, a) =>
              v.ses_termname !== null &&
              v.ses_termname !== undefined &&
              a.findIndex((t) => t.ses_termname === v.ses_termname) === i,
          )
          .sort(
            (a, b) =>
              new Date(b.ses_startdate).getTime() -
              new Date(a.ses_startdate).getTime(),
          );
      if (field === "status")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_studentstatus === v.ses_studentstatus) ===
            i,
        );
    }
    return [];
  };
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const compareDate = (element) => {
    if (
      element._ses_term_value === null &&
      element._usb_subterm_value === null
    ) {
      return false;
    }
    if (element.ses_lastdatetowithdraw === null) {
      return false;
    }

    // Get current date/time in CT timezone (USB always works in CT)
    var currentDate = getCurrentDateTimeInCT();
    // Database date is stored in CT (no timezone info), parse it as CT
    var givenDate = parseDatabaseDateAsCT(element.ses_lastdatetowithdraw);
    if (currentDate.getTime() <= givenDate.getTime()) return true; // enabled

    return false; // disabled
  };
  const attendanceData = useSelector((state) => state.classData.attendance);

  useEffect(() => {
    if (attendanceData.length > 0) {
      const attendances = [...attendanceData];
      setModalTableMapData(
        attendances.sort(
          (item1, item2) => new Date(item1.ses_date) - new Date(item2.ses_date),
        ),
      );
    }
  }, [attendanceData]);

  const handleModalClose = () => {
    setModalTableMapData([]);
    setOpenModal(false);
  };
  useEffect(() => {
    if (
      (classData.length > 0 || !isObjectEmpty(classData)) &&
      classData !== undefined
    ) {
      const removeEmptyObjmodalData = classData?.data?.filter(
        (value) => Object.keys(value).length !== 0,
      );
  
      const sortedData = removeEmptyObjmodalData.sort((a, b) => {
        // Convert to date-only string: "YYYY-MM-DD"
        const dayA = new Date(a.ses_startdate).toISOString().split("T")[0];
        const dayB = new Date(b.ses_startdate).toISOString().split("T")[0];
  
        if (dayA > dayB) return -1; // Newest first
        if (dayA < dayB) return 1;
  
        // If same day, sort by class name A-Z
        return a.ses_institutionclassid.localeCompare(b.ses_institutionclassid);
      });
  
      setTotalData(sortedData);
  
      const copyData = sortedData.filter(
        (element) => element.ses_studentstatus === 284210000,
      );
  
      if (copyData.length > 0) setStatuses(284210000);
      setTableMapData(copyData);
    }
  }, [classData]);

  let tableData = "";
  let termData = "";
  let statusData = "";
  if (!isObjectEmpty(classData?.data)) {
    if (classData?.data) {
      if (Array.isArray(classData?.data)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell> {element.ses_termname}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {element.ses_institutionclassid} 
                      </StyledTableCell>
                      <StyledTableCell>{element.ses_classname}</StyledTableCell>
                      <StyledTableCell>{element.ses_room}</StyledTableCell>
                      <StyledTableCell>{element.ses_schedule}</StyledTableCell>
                      <StyledTableCell>
                        {element.ses_creditstaken === 0 && "0.00"}
                        {element.ses_creditstaken
                          ? element.ses_creditstaken.toFixed(2)
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell>
                        {funcOptionList(element.ses_studentstatus)}
                      </StyledTableCell>
                      <StyledTableCell>
                        <IconButton
                          color="secoundary"
                          disabled={
                            !compareDate(element) ||
                            element.usb_canregister === false
                          }
                          onClick={(e) =>
                            handleOpenModal(e, element.ses_sessionid, element)
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;
        statusData = removeDuplicateFromObjects(classData.data, "status").map(
          (element, index) => (
            <MenuItem value={element.ses_studentstatus} key={index}>
              {funcOptionList(element.ses_studentstatus)}
            </MenuItem>
          ),
        );
        termData = removeDuplicateFromObjects(classData.data, "termName").map(
          (element, index) => (
            <MenuItem value={element.ses_termname} key={index}>
              {element.ses_termname}
            </MenuItem>
          ),
        );
      }
    }
  }

  const handleChange = (event) => {
    const copyTableMapData = [...totalData];
    if (event.target.value.length === 0) {
      setTableMapData(copyTableMapData);
    }
    // term
    if (event.target.name === "term") {
      let copyData = copyTableMapData.filter(
        (element) => element.ses_termname === event.target.value,
      );
      setTerms(event.target.value);
      setTableMapData(copyData);
    }
    // term
    if (event.target.name === "term" && statusesData != "") {
      let copyData;
      copyData = copyTableMapData.filter(
        (element) =>
          element.ses_termname === event.target.value &&
          element.ses_studentstatus === statusesData,
      );
      if (event.target.value === "") {
        copyData = copyTableMapData.filter(
          (element) => element.ses_studentstatus === statusesData,
        );
        if (event.target.value === "" && statusesData === "") {
          copyData = copyTableMapData;
        }
      }
      setTerms(event.target.value);
      setTableMapData(copyData);
    }
    // status
    if (event.target.name === "status") {
      let copyData = copyTableMapData.filter(
        (element) => element.ses_studentstatus === event.target.value,
      );
      setStatuses(event.target.value);
      setTableMapData(copyData);
    }

    // status
    if (event.target.name === "status" && termsData != "") {
      let copyData;
      copyData = copyTableMapData.filter(
        (element) =>
          element.ses_studentstatus === event.target.value &&
          element.ses_termname === termsData,
      );
      if (event.target.value === "") {
        copyData = copyTableMapData.filter(
          (element) => element.ses_termname === termsData,
        );
        if (event.target.value === "" && termsData === "") {
          copyData = copyTableMapData;
        }
      }
      setStatuses(event.target.value);
      setTableMapData(copyData);
    }

    if (
      (event.target.name === "status" &&
        event.target.value === "" &&
        termsData === "") ||
      (event.target.name === "term" &&
        event.target.value === "" &&
        statusesData === "")
    ) {
      setTableMapData(copyTableMapData);
    }
  };

  useEffect(() => {
    if (error.message === "No attendance record available") {
      setDisplayMessage(localizedStrings.general.noattendanceMessage);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (
      error.message === "Invalid token or you are missing header token"
    ) {
      setDisplayMessage(localizedStrings.general.invalidTokenandheader);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [error]);

  // Custom label for the "of" keyword in TablePagination
  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };

  const handleCloseModal = () => setOpen(false);
  const handleCloseModal1 = () => setOpen1(false);
  const handlecorequire = () => {
    setOpen1(false);
    setOpen(true);
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Attendance
        open={openModal}
        tableMapData={modalTableMapData}
        onHandleClose={handleModalClose}
      />
      {localizedStrings._language === "en" && (
        <span
          style={{ fontSize: "1rem", fontWeight: 400, marginBottom: "15px" }}
        >
          You can also check your registration under “Classes”. To withdraw from
          a course before the withdrawal deadline (with or without a refund),
          you should select the trash can. Before completing this step, please
          check the{" "}
          <a
            href="https://ustboniface.ca/dates"
            target="_blank"
            style={{ marginRight: "3px" }}
          >
            drop deadlines
          </a>
          to see whether or not you will be eligible for a refund. Dropping the
          class without a refund cannot be reversed.
        </span>
      )}

      {localizedStrings._language === "fr" && (
        <span
          style={{ fontSize: "1rem", fontWeight: 400, marginBottom: "15px" }}
        >
          Vous pouvez aussi vérifier votre inscription sous « Classes ». Pour
          abandonner un cours avant la date limite d’abandon (avec ou sans
          remboursement), vous pouvez sélectionner la corbeille. Avant
          d’effectuer cette étape, veuillez vérifier les
          <a href="https://ustboniface.ca/dates" target="_blank">
            {" "}
            dates limites{" "}
          </a>
          d’abandon pour voir si vous aurez droit ou non à un remboursement. Les
          abandons sans remboursement ne pourront pas être renversés
        </span>
      )}

      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <div className={classes.TableControl}>
                  {localizedStrings.students.classes.table.term}{" "}
                  <FormControl className={classes.formControl}>
                    <Select
                      value={termsData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="term"
                    >
                      <MenuItem value="">
                        {localizedStrings.students.classes.table.allTerms}{" "}
                      </MenuItem>
                      {termData}
                    </Select>
                  </FormControl>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.classId}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.class}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.room}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.schedule}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.credits}
              </StyledTableCell>
              <StyledTableCell>
                <div className={classes.TableControl}>
                  {localizedStrings.students.classes.table.status}
                  <FormControl className={classes.formControl}>
                    <Select
                      value={statusesData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="status"
                    >
                      <MenuItem value="">
                        {localizedStrings.students.classes.table.status}{" "}
                      </MenuItem>
                      {statusData}
                    </Select>
                  </FormControl>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                {" "}
                {localizedStrings.students.classes.table.action}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tableMapData.length > 0 ? tableMapData.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={
            <span style={{ textTransform: "none" }}>
              {localizedStrings.rows.rowsperpage}
            </span>
          }
          labelDisplayedRows={customLabelDisplayedRows}
        />
      </TableContainer>

      <Modal
        open={open1}
        onClose={handleCloseModal1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            width: "50vh",
            marginTop: "5rem",
            marginLeft: "35rem",
            background: "white",
            borderRadius: "6px",
            padding: "1rem",
          }}
        >
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div>
              {localizedStrings.students.classes.table.warningcorequisitemsg}

              <br />
              <br />
              <Button
                style={{
                  backgroundColor: "#005598",
                  color: "white",
                  marginRight: "10px",
                }}
                onClick={handlecorequire}
              >
                {localizedStrings.students.classes.table.continue}
              </Button>
              <Button
                style={{
                  backgroundColor: "#005598",
                  color: "white",
                }}
                onClick={handleCloseModal1}
              >
                {localizedStrings.students.classes.table.cancel}
              </Button>
            </div>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            width: "50vh",
            marginTop: "5rem",
            marginLeft: "35rem",
            background: "white",
            borderRadius: "6px",
            padding: "1rem",
          }}
        >
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div>
              {localizedStrings.students.classes.table.warningmsg}
              <br />
              <br />
              <Button
                style={{
                  backgroundColor: "#005598",
                  color: "white",
                  marginRight: "10px",
                }}
                onClick={handleUpdate}
              >
                {localizedStrings.students.classes.table.continue}
              </Button>
              <Button
                style={{
                  backgroundColor: "#005598",
                  color: "white",
                }}
                onClick={handleCloseModal}
              >
                {localizedStrings.students.classes.table.cancel}
              </Button>
            </div>
          </Typography>
        </Box>
      </Modal>
    </Aux>
  );
}

export default withRouter(PageConatiner);
